import { StyleSheet, Text, View } from "react-native";
import React from "react";

const Post = () => {
  return (
    <View>
      <Text>Post</Text>
    </View>
  );
};

export default Post;

const styles = StyleSheet.create({});
